<template>
  <div>
    <q-dialog
      :visible.sync="dialogVisible"
      :title="title"
      :innerHeight="120"
      :innerScroll="false"
      :qLoading="confirmLoading"
      width="1200px"
      @cancel="updateVal"
      @confirm="confirm"
      @close="updateVal"
    >
      <!-- // 业务 -->
      <div style="text-align: right; margin-bottom: 15px;">
        <el-button type="primary" size="small" @click="addSku">新增SKU</el-button>
      </div>
      <el-form
        :model="formItem"
        size="small"
        :inline="true"
        :rules="rules"
        ref="ruleForm"
        label-width="80px"
        v-loading="loading"
        v-for="(formItem, index) in form" :key="index"
        >
        <el-form-item label="SKU编码" prop="skuCode">
          <el-autocomplete v-if="isRemake || isShowInput"
            class="form-input"
            v-model="formItem.skuCode"
            :fetch-suggestions="querySkuList"
            @select="handleSelect"
            @focus="onSkuCodeFocus"
          ></el-autocomplete>
          <el-input v-else v-model.trim="formItem.skuCode" style="width: 1000px" @blur="handleSkuCodeModify" />
        </el-form-item>
        <el-form-item label="商品定位" prop="goodsLocation">
          <el-select v-model="formItem.goodsLocation" filterable>
            <el-option :label="item.optionValue" :value="item.id" v-for="item in locationOpt" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="风格" prop="style">
          <el-select v-model="formItem.style" filterable>
            <el-option :label="item.optionValue" :value="item.id" v-for="item in styleList" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否有样" prop="sampleFlag">
          <el-select v-model="formItem.sampleFlag">
            <el-option label="是" value="是"></el-option>
            <el-option label="否" value="否"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="width: 80px; text-align: right;">
          <el-link type="primary" :underline="false" @click="asyncField(index)">同属性</el-link>
          <el-link type="primary" :underline="false" @click="delSku(index)">删除</el-link>
        </el-form-item>
      </el-form>
      <el-form :model="form2" size="small" :inline="true" ref="ruleForm2" label-width="80px">
        <el-form-item label="同进度">
          <el-select v-model="form2.sameProgress" :disabled="isSkip" @change="form2.oldSkuCode = ''">
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="SKU编码" :rules=" form2.sameProgress == 1 ? [{ required: true, message: '请选SKU编码', trigger: 'change' }] : []" prop="oldSkuCode">
          <el-select v-model="form2.oldSkuCode" :disabled="form2.sameProgress === 0">
            <el-option
              :label="`${skuInfo.skuCode}-${skuInfo.taskName}`"
              :value="skuInfo.skuCode"
              v-for="skuInfo in finalSkuList" :key="skuInfo.code"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </q-dialog>
  </div>
</template>

<script>
import {assignValue} from '@/utils'
export default {
  model: {
    prop: 'visible',
    event: 'input'
  },
  props: {
    visible: Boolean,
    skuList: Array,
    spuId: String|Number,
    spuInfo: Object
  },
  computed: {
    title() {
      return this.skuCode ? '修改SKU' : '新增SKU';
    },
    // 过滤掉处于开始上架&完成上架节点的sku
    finalSkuList() {
      return this.skuList.filter(v=>{
        return (v.taskId != 100 && v.taskId != 110)
      })
    },
    // 是否翻拍
    isRemake() {
      return +this.spuInfo.productTypeCode === 2;
    },
    // 是否存在跳过节点
    isSkip() {
      return this.spuInfo.allSkipTask && this.spuInfo.allSkipTask.length > 0
    },
    // 类别为这些也可以搜索
    isShowInput() {
      return ['新品-多页面', '新品-无限制', '店铺专供'].includes(this.spuInfo.productTypeName)
    }
  },
  data() {
    return {
      dialogVisible: false,
      // 业务
      locationOpt: [],
      styleList: [],
      form: [{
        dataId: '',
        spuId: '',
        skuCode: '',
        goodsLocation: '',
        style: '',
        sampleFlag: ''
      }],
      form2: {
        sameProgress: 0,
        oldSkuCode: ''
      },
      rules: {
        skuCode: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ]
      },
      loading: false,
      isSelect: '',
      confirmLoading: false
    }
  },
  created() {
    console.log(this.isShowInput);
    if(this.isSkip) {
      this.$set(this.form2,'sameProgress',1)
    }
    this.init();
  },
  methods: {
    updateVal() {
      this.dialogVisible = false;
      setTimeout(_=>{
        this.$emit('input', false)
      },200)
    },
    confirm() {
      let status = [];
      let validType = true
      this.$refs['ruleForm'].forEach($instance=>{
        $instance.validate(valid=>{
          status.push(valid)
        })
      })
      if(status.indexOf(false) > -1) {
        return;
      }
      this.$refs['ruleForm2'].validate(valid => {
        validType = valid
      })
      if (!validType) return
      
      this.confirmLoading = true;
      this.form.forEach(item=>{
        item['spuId'] = this.spuId;
        item['isSelect'] = this.isSelect;
        item['sameProgress'] = this.form2.sameProgress;
        if(this.form2.sameProgress == 1) {
          item['oldSkuCode'] = this.form2.oldSkuCode;
          item['oldSkuId'] = this.finalSkuList.length && this.finalSkuList.find(v=>v.skuCode == this.form2.oldSkuCode).dataId || '';
        }
      })
      const params = {
        data: this.form
      }
      this.$q.newProduct.editSku(params)
        .then(({success}) => {
          if (success) {
            this.$notify.success({
              title: '成功',
              message: `${this.skuCode ? '修改' : '新增'}SKU成功`,
            });
            this.updateVal();
            this.$emit('success', null);
          }
        })
        .finally(() => {
          this.confirmLoading = false;
        });
    },
    async init() {
      this.dialogVisible = this.visible;
      await this.get_goodsAttrLocationSelect();
      await this.getOptionType();
      if(!this.finalSkuList.length) return;
      this.form[0].goodsLocation = this.finalSkuList[0].goodsLocation
      this.form[0].style = this.finalSkuList[0].style
      this.form[0].sampleFlag = this.finalSkuList[0].sampleFlag
    },
    // (商品属性维护页面搜索)商品定位下拉数据
    get_goodsAttrLocationSelect() {
      return this.$q.goods.goodsAttrLocationSelect().then(res => {
        this.locationOpt = res.data;
      }).catch(console.log);
    },
    // 获取风格下拉选项
    getOptionType() {
      return this.$q.goods.goodsQueryOptionType().then(res => {
        this.styleList = res.data.styleList;
      }).catch(console.log);
    },
    querySkuList(queryString, cb) {
      this.$q.newProduct.querySku({
          params: {
            skuCode: queryString
          }
        })
        .then(({data}) => {
          let results = queryString 
            ? data.filter(item => item.skuCode.toLowerCase().includes(queryString.toLowerCase()))
            : data;
          results = results.map(item => ({
            ...item,
            value: item.skuCode
          }));
          // 调用 callback 返回建议列表的数据
          cb(results);
        });
    },
    handleSkuCodeModify() {
      this.isSelect = '否';
    },
    handleSelect(item) {
      this.isSelect = '是';
      this.form.skuCode = item.value;
      // this.$refs.ruleForm.validateField('skuCode');
    },
    onSkuCodeFocus() {
      this.isSelect = '否';
    },
    addSku() {
      this.form.push({
        dataId: '',
        spuId: '',
        skuCode: '',
        goodsLocation: '',
        style: '',
        sampleFlag: ''
      })
    },
    delSku(i) {
      this.form.splice(i,1)
    },
    asyncField(i) {
      this.addSku();
      // this.form.forEach((item, index) =>{
      //   if(index !== i) {
      //     item['goodsLocation'] = this.form[i].goodsLocation;
      //     item['style'] = this.form[i].style;
      //     item['sampleFlag'] = this.form[i].sampleFlag;
      //   }
      // })
      this.form[this.form.length - 1]['goodsLocation'] = this.form[i].goodsLocation;
      this.form[this.form.length - 1]['style'] = this.form[i].style;
      this.form[this.form.length - 1]['sampleFlag'] = this.form[i].sampleFlag;
    }
  }
}
</script>

<style lang="stylus" scoped>

  .form-input  >>> .el-input {
    width: 1000px;
  }
</style>
